import type { FaireProductEntity } from "../../entity_types/product";

export const casa_bosques_1: FaireProductEntity = {
  token: "casa-bosques-1",
  type: "product",
  name: "Dried Fruits - Russ & Daughters",
  brandName: "Casa Bosques",
  imageUrl:
    "https://cdn.faire.com/fastly/aa243ceeb9c2b926180d207a116276237980a2ad1b11eccf0b6286523b8b686e.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 10,
  msrpDollars: 20,
  freeShipping: true,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
